export default __webpack_public_path__ + "static/media/Legion Spellwarders Ring.4bba3333.jpg";